import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import './SuccessfulPurchase.css';
//icons
import logo from '../../assets/logo.png';
import successIcon from '../../assets/SuccessIcon.png';
import errorIcon from '../../assets/errorIcon.png';
import purchaseIcon from '../../assets/purchasePackage.png';

const SuccessfulPurchase = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { isSuccessful, title, highlight, message, titleButton } = state || {};

  const onAccept = () => {
    navigate(-1);
  }

  return (
    <div className='successful-purchase'>
      <img src={logo} alt={t('packages.logoAlt')} className="logo-success" />
      
      <div className="success-content">
        {isSuccessful ? (
          <img src={purchaseIcon} alt={t('packages.successIconAlt')} className="success-icon" />
        ) : (
          <img src={errorIcon} alt={t('packages.errorIconAlt')} className="success-icon" />
        )}
        
        <h1 className="success-title">
          {title} <span className={isSuccessful ? 'highlight' : 'error-highlight'}>{highlight}</span>
        </h1>
        
        <p className="success-message">{message}</p>
      </div>

      <button className="accept-button" onClick={onAccept}>
        {titleButton}
      </button>
    </div>
  );
};

export default SuccessfulPurchase;
